import Icon from '$store/components/ui/Icon.tsx'
import { TimerConfig } from '$store/loaders/timers.tsx'
import { useTimer } from '$store/sdk/useTimer.ts'

export interface Props {
    timers: TimerConfig[]
}

function ShelfTimer({ timers = [] }: Props) {
    // Pode ser útil para definir a ordem de prioridade (por enquanto só pega o primeiro elemento)
    const timer = timers.find(() => true)

    if (!timer) return <div class='mt-auto' />

    const { start, end, layout } = timer

    const startDate = (start ? new Date(start) : new Date()).getTime()
    const endDate = new Date(end).getTime()

    const timeLeft = useTimer({ startDate, endDate })

    if (timeLeft.status !== 'in-progress') return null

    const hours = timeLeft.hours.toString().padStart(2, '0')
    const minutes = timeLeft.minutes.toString().padStart(2, '0')
    const seconds = timeLeft.seconds.toString().padStart(2, '0')

    return (
        <div class='flex w-full h-[45px] px-3 md:px-0 mt-2 bg-white group-hover:left-full duration-500'>
            <span
                class='flex items-center justify-center w-[45px] h-[45px] rounded-s-md bg-primary'
                style={{ backgroundColor: layout?.bgColor }}
            >
                <Icon id='Timer' width={24} height={23} class='text-white' />
            </span>
            <div
                class='flex items-center justify-center flex-wrap grow gap-x-1 py-1 leading-none text-center border border-primary rounded-e-md'
                style={{
                    border: layout?.bgColor ? `1px solid ${layout.bgColor}` : undefined,
                }}
            >
                <span
                    class='text-sm text-primary uppercase font-semibold whitespace-nowrap leading-none'
                    style={{ color: layout?.bgColor }}
                >
                    Termina em:
                </span>{' '}
                <span
                    class='text-sm text-[#191A45] font-semibold leading-none w-[58px]'
                    style={{ color: layout?.textColor }}
                >
                    {hours}:{minutes}:{seconds}
                </span>
            </div>
        </div>
    )
}

export default ShelfTimer
